import shapesIcon    from '@/TokamapEditor/ux/icons/shapes-icon.png';
import useThemeMode  from '@widesk-ui/hooks/useThemeMode';

/**
 * Icône "Formes" (section racine du menu de gauche) — image PNG fournie par l'utilisateur (triangle/
 * carré/cercle qui se chevauchent, carré au-dessus), plutôt qu'une reconstruction SVG maison : les
 * tentatives de reproduction en SVG (voir l'historique de ce fichier) n'ont pas donné un résultat
 * satisfaisant. Le fichier source a été retraité avant intégration (`shapes-icon.png`) : fond
 * "damier" (transparence non préservée dans l'export d'origine) reconverti en vrai canal alpha,
 * rogné à la zone utile, léger padding, redimensionné à une taille d'icône (256px de haut) — pas
 * utilisé tel quel.
 *
 * Le PNG est noir sur fond transparent, sans variante par thème (contrairement aux icônes AntD, qui
 * suivent `currentColor`) — invisible sur le fond sombre du menu en thème `dark`. `filter:
 * invert(1)` retourne le noir en blanc sans toucher la transparence (l'alpha n'est pas affecté par
 * `invert`), plutôt que de fournir 2 fichiers PNG séparés.
 */
export default function ShapesIcon({ size = 24 }: { size?: number; }) {
	const { mode } = useThemeMode();

	return (
		<img
			src={shapesIcon}
			alt="formes"
			style={{ height: size, width: 'auto', display: 'block', filter: mode === 'dark' ? 'invert(1)' : undefined }}
		/>
	);
}
